// Component: src/theme/snippets/saved-schools-modal.liquid

import { EVENT_RELOAD_HISTORY_LIST } from "@app/components/search";
import { isDescendant } from "@app/utils/isDescendant";

export const SAVED_SCHOOL_KEY = "saved-schools";
export const EVENT_RELOAD_SAVED_SCHOOLS = "reload-saved-schools";

export class SavedSchoolsModal extends HTMLElement {
  $list!: HTMLElement;
  $emptyContent!: HTMLElement;
  $button!: HTMLButtonElement;

  constructor() {
    super();
  }

  connectedCallback() {
    this.$list = this.querySelector(".school-list")!;
    this.$emptyContent = this.querySelector(".empty-content")!;
    this.$button = document.getElementById("saved-schools-button") as HTMLButtonElement;
    this.loadSavedSchools();

    this.$button?.addEventListener("click", () => {
      if (this.classList.contains("hidden")) {
        setTimeout(() => {
          this.open();
          window.headerSearch.hideMobileSearch();
        }, 1);
      } else {
        this.close();
      }
    });

    document.addEventListener("click", (event) => {
      if (!this.classList.contains("hidden")) {
        if (!isDescendant(this, event.target)) {
          this.close();
        }
      }
    });

    document.addEventListener(EVENT_RELOAD_SAVED_SCHOOLS, () => {
      this.loadSavedSchools();
    });
  }

  toggle() {
    this.classList.toggle("hidden");
  }

  open() {
    this.classList.remove("hidden");
  }

  close() {
    this.classList.add("hidden");
  }

  loadSavedSchools() {
    let collections: any = localStorage.getItem(SAVED_SCHOOL_KEY) || "[]";
    collections = JSON.parse(collections);

    this.$list.innerHTML = "";

    if (!collections.length) {
      this.showEmptyContent();
      return;
    }

    collections.forEach((collection: any) => {
      const $item = document.createElement("a");
      $item.classList.add("school-list-item");
      $item.href = collection.url;

      const $image = document.createElement("div");
      $image.classList.add("item-image");
      $image.innerHTML = `<img src="${collection.featured_image.url}" alt="${collection.title}" />`;
      $item.appendChild($image);

      const $text = document.createElement("div");
      $text.classList.add("item-title");
      $text.innerHTML = collection.title;
      $item.appendChild($text);

      const $close = document.createElement("button");
      $close.classList.add("item-close");
      $close.innerHTML = window.iconCloseXs;
      $item.appendChild($close);
      $close.addEventListener("click", (e) => {
        e.preventDefault();
        this.removeSchool(collection);
        document.dispatchEvent(new Event(EVENT_RELOAD_HISTORY_LIST));
        document.dispatchEvent(new Event(EVENT_RELOAD_SAVED_SCHOOLS));
      });

      this.$list.appendChild($item);
    });

    this.$list.classList.remove("hidden");
  }

  showEmptyContent() {
    this.$list.classList.add("hidden");
    this.$emptyContent.classList.remove("hidden");
  }

  public saveSchool(school: any) {
    let schools: any = localStorage.getItem(SAVED_SCHOOL_KEY) || "[]";
    schools = JSON.parse(schools);
    if (schools.find((s: any) => s.id === school.id)) {
      return;
    }
    schools.push(school);
    localStorage.setItem(SAVED_SCHOOL_KEY, JSON.stringify(schools));
  }

  public removeSchool(school: any) {
    let schools: any = localStorage.getItem(SAVED_SCHOOL_KEY) || "[]";
    schools = JSON.parse(schools);
    schools = schools.filter((s: any) => s.id !== school.id);
    localStorage.setItem(SAVED_SCHOOL_KEY, JSON.stringify(schools));
  }
}

customElements.define("saved-schools-modal", SavedSchoolsModal);
